const SCROLL_TARGET_KEY = 'adx-scroll-target';
const NAV_OFFSET = 108;
const LENIS_DURATION = 1.1;

export function parseSectionId(target) {
  if (!target) return '';
  const value = String(target).trim();
  if (!value) return '';

  const hashIndex = value.indexOf('#');
  if (hashIndex >= 0) {
    return value.slice(hashIndex + 1);
  }

  return value.startsWith('/') ? '' : value.replace(/^#/, '');
}

export function scrollToSection(target, options = {}) {
  const sectionId = parseSectionId(target);
  if (!sectionId) return false;

  const section = document.getElementById(sectionId);
  if (!section) return false;

  const behavior = options.behavior ?? 'smooth';
  const lenis = window.__lenis;
  const isImmediate = behavior === 'auto' || behavior === 'instant';

  if (lenis && typeof lenis.scrollTo === 'function') {
    lenis.scrollTo(section, {
      offset: -NAV_OFFSET,
      duration: isImmediate ? 0 : LENIS_DURATION,
      immediate: isImmediate,
    });
  } else {
    section.scrollIntoView({ behavior, block: 'start' });
  }

  if (window.location.hash) {
    window.history.replaceState({}, '', `${window.location.pathname}${window.location.search}`);
  }

  return true;
}

export function setPendingSection(sectionId) {
  if (!sectionId) return;
  window.sessionStorage.setItem(SCROLL_TARGET_KEY, sectionId);
}

export function consumePendingSection() {
  const sectionId = window.sessionStorage.getItem(SCROLL_TARGET_KEY);
  if (!sectionId) return '';
  window.sessionStorage.removeItem(SCROLL_TARGET_KEY);
  return sectionId;
}
